import Permissions from '../../models/Permissions'
const Create = () => import(/* webpackChunkName: "editcompany" */ './Create.vue')
const Index = () => import(/* webpackChunkName: "companies" */ './Index.vue')

const permissions = [
  Permissions.ROOT
]

const create = {
  path: 'addcompany',
  name: 'Cliente',
  component: Create,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const modify = {
  path: 'companies',
  name: 'Modificar Cliente',
  component: Index,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const edit = {
  path: 'editcompany/:cpfCnpj',
  name: 'Edição de Cliente',
  component: Create,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

export default {
  create,
  modify,
  edit
}



// WEBPACK FOOTER //
// ./src/views/company/index.js